export default __webpack_public_path__ + "static/elevator_w.33c04ba9339d1d88051debdb02142051.svg";